import React from 'react'
import ProfileComponent from '../../components/ProfileComponent/ProfileComponent';
import  "./HeaderSection.css"
import NextLogo from "../../assets/myorders-next-logo.svg"
import { Avatar } from 'antd';

const HeaderSection = () => {
  return (
    <div className="header-container">
      <div className="header-logo">
        <a href='/'><img src={NextLogo} alt="Logo" /> </a>
      </div>
      <ProfileComponent/>
    </div>
  )
}
export default HeaderSection;